import axios, { AxiosRequestConfig, InternalAxiosRequestConfig } from "axios";
// import { isLocal } from "./constant.util";
import { getFromSessionStorage } from "./helper";
// import { errorLogger } from "utils/helper";

const request = () => {
  const defaultOptions = {
    // baseURL: "http://localhost:4000/api/v1",
    baseURL: "https://be.tms.bestafpayments.com/api/v1",
  };
  // Create instance
  let instance = axios.create(defaultOptions);

  // Add request interceptor
  instance.interceptors.request.use(function (
    config: AxiosRequestConfig<any>
  ):
    | InternalAxiosRequestConfig<any>
    | Promise<InternalAxiosRequestConfig<any>> {
    const token = getFromSessionStorage("TOKEN");
    const cleanToken = (token ?? "").replace(/^"|"$/g, "");

    config.headers = {
      Authorization: token ? `Bearer ${cleanToken}` : "",
    };
    return config as any;
  });


  return instance;
};

export default request();
